import { render, staticRenderFns } from "./FoodMenu.vue?vue&type=template&id=c91d1e1e&"
import script from "./FoodMenu.vue?vue&type=script&lang=js&"
export * from "./FoodMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports